import logger from '../logger';

export const getItem = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    logger.error(`[storage] Error setting key "${key}":`, error);
  }
};

export const removeItem = (key) => {
  try {
    localStorage.removeItem(key);
  } catch {
    // localStorage puede fallar en modo privado o sin espacio
  }
};

export const clear = () => {
  try {
    localStorage.clear();
  } catch {
    // localStorage puede fallar en modo privado o sin espacio
  }
};
